// Parse abbreviated numbers coming from Webull: "1.01M", "584.46K", "2.5B", "5,315.92%"
// Handles French decimal comma: "0,1024" → 0.1024. Handles thousands separators too:
// "5,315.92" → 5315.92 (US). "1 234,56" → 1234.56 (FR).
export function parseAbbrev(input) {
  if (input === null || input === undefined) return null;
  if (typeof input === "number") return input;
  let s = String(input).trim();
  if (!s || s === "--" || s.toLowerCase() === "n/a") return null;
  s = s.replace(/\s/g, "").replace(/%$/, "");
  // Distinguish decimal comma (FR) from thousands separator.
  // Heuristic: if the string contains a comma but no dot AND the comma appears
  // exactly once, treat it as a decimal separator. Otherwise, commas are
  // thousands separators and get removed.
  const commaCount = (s.match(/,/g) || []).length;
  const hasDot = s.includes(".");
  if (commaCount === 1 && !hasDot) {
    s = s.replace(",", ".");
  } else {
    s = s.replace(/,/g, "");
  }
  const m = s.match(/^(-?\d*\.?\d+)([KkMmBbTt]?)$/);
  if (!m) {
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  }
  const base = parseFloat(m[1]);
  const suf = m[2].toUpperCase();
  const mult = { "": 1, K: 1e3, M: 1e6, B: 1e9, T: 1e12 }[suf];
  return base * mult;
}

export function formatMoney(v, digits = 2) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return `${Number(v).toLocaleString("fr-FR", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })} $`;
}

export function formatPct(v, digits = 2) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return `${Number(v) >= 0 ? "+" : ""}${Number(v).toFixed(digits)} %`;
}

export function formatAbbrev(v) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  const abs = Math.abs(v);
  if (abs >= 1e9) return `${(v / 1e9).toFixed(2)} G`;
  if (abs >= 1e6) return `${(v / 1e6).toFixed(2)} M`;
  if (abs >= 1e3) return `${(v / 1e3).toFixed(2)} K`;
  return String(v);
}
